export default {
  presets: {
    light: {
      backgroundPrimary: '#F4F6F8',
      backgroundSecondary: '#FFFFFF',
      backgroundCardPrimary: '#F7F9F9',
      backgroundCardSecondary: '#ECFDE6',
      // Vuestic's default secondary is #767C88, which is below AA both ways:
      // white on it is 4.19 (the VACATION report banner) and it is 3.87 as
      // muted text on the page, which is what `text-secondary` renders in ~30
      // places. Same hue (220deg) and saturation, two points of lightness
      // darker: 4.63 with white, 4.28 as text. Still clearly a muted grey.
      secondary: '#6F7580',
      success: '#228200',
      // Deepened from #158DE3, which put white text on it at 3.53:1 - below AA
      // for small text, so every SUBMITTED report banner, info toast and DRAFT
      // badge was slightly under-legible. Same hue (205deg) and saturation, one
      // shade darker: 4.56:1 with white, and better as text on the page too.
      info: '#127AC4',
      danger: '#E42222',
      warning: '#FFD43A',
    },
  },
}
